import es from './es-AR';
import en from './en-US';


export default {
    ...es,
    ...en
}